<template>
<div>
    <v-card>
        <v-card-text>
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12 sm6>
                        <table>
                            <tr>
                                <th>Код</th>
                                <td>{{systemInfo.id}}</td>
                            </tr>
                            <tr>
                                <th>Дата создания</th>
                                <td>{{ systemInfo.date_created|date_time }}</td>
                            </tr>
                            <tr>
                                <th>Дата модификации</th>
                                <td>{{ systemInfo.date_of_change|date_time }}</td>
                            </tr>

                        </table>
                    </v-flex>
                    <v-flex xs12 sm6 v-if="'user' in systemInfo">
                        <table>
                            <tr v-if="'full_name' in systemInfo.user">
                                <th>Пользователь</th>
                                <td>{{systemInfo.user.full_name}}</td>
                            </tr>
                            <tr v-if="'title' in systemInfo.user">
                                <th>Должность</th>
                                <td>{{systemInfo.user.title}}</td>
                            </tr>
                            <tr v-if="'office_phone' in systemInfo.user">
                                <th>Рабочий телефон</th>
                                <td>{{systemInfo.user.office_phone}}</td>
                            </tr>
                            <tr v-if="'department' in systemInfo.user">
                                <th>Организация</th>
                                <td>{{systemInfo.user.department}}</td>
                            </tr>
                        </table>
                    </v-flex>

                </v-layout>
            </v-container>
        </v-card-text>
    </v-card>
</div>
</template>

<script>
export default {
  name: 'systemForm',
  props: {
    systemInfo: Object
  }
}

</script>

<style scoped>
    td, th {
        text-align: left;
        padding: 5px;
    }

    th {
        vertical-align: top
    }

    .bloc_inline {
        display: inline-block;
    }
</style>
